import React from 'react';
export default () => (<p>Unsupported field type</p>);



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Renderer/Fields/Unsupported.js